import { CompanyBrand, normalizeCompanyBrand } from '../brand/types';

export const extractBrandFromAuthResponse = (response: {
  brand?: Partial<CompanyBrand>;
}): CompanyBrand | null => {
  if (!response?.brand) return null;
  return normalizeCompanyBrand(response.brand);
};
